"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const PhotoLibrarySystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "PHOTO-LIBRARY-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M22.143 3.536a.75.75 0 0 1 .75.75v18c0 .887-.72 1.607-1.607 1.607H5a.75.75 0 1 1 0-1.5h16.286c.059 0 .107-.048.107-.107v-18a.75.75 0 0 1 .75-.75M17.964.107a1.5 1.5 0 0 1 1.5 1.5v17.357a1.5 1.5 0 0 1-1.5 1.5H2.321a1.5 1.5 0 0 1-1.5-1.5V1.607a1.5 1.5 0 0 1 1.5-1.5h15.643Zm0 15.214H2.32v3.643h15.643v-3.643m0-13.714H2.321v12.214h4.002l4.523-6.46a2.464 2.464 0 0 1 1.698-1.029l.187-.017a2.464 2.464 0 0 1 1.988.837l3.244 3.708.001-9.253m-5.151 6.205a.964.964 0 0 0-.738.41l-3.92 5.6h9.808v-.685L13.59 8.14a.964.964 0 0 0-.652-.326ZM5.857 3.964a1.179 1.179 0 1 1 0 2.357 1.179 1.179 0 0 1 0-2.357"
  }));
};
PhotoLibrarySystemIcon.displayName = "PhotoLibrarySystemIcon";
PhotoLibrarySystemIcon.iconName = "PhotoLibrary";
export default PhotoLibrarySystemIcon;